exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "div{width:100%;height:20%;padding-bottom:56%}iframe{width:100%;height:100%;position:absolute;display:block;top:0;left:0}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history/invoice-history.component.css"],"names":[],"mappings":"AAAA,IACE,WAAY,WACA,kBACQ,CACrB,OAGG,WAAY,YACC,kBACM,cACJ,MACR,MACC,CACX","file":"invoice-history.component.css","sourcesContent":["div {\n  width: 100%;\n  height: 20%;\n  padding-bottom: 56%; /* Change this till it fits the dimensions of your video */\n}\n\niframe {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history/invoice-history.component.css
// module id = 7twq
// module chunks = 0